/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import { HierarchyListItemHandler } from "../handlers/HierarchyListItemHandler";

export class BreadcrumbItemsHandler {
    
    constructor(){
        this.breadcrumbItemList=[];
        this.breadcrumbHierarchyListItemHandler = new HierarchyListItemHandler();
    }

    getBreadcrumbItems(menuitems,currentSelectedMenuItemId,isSubPage){
        this.breadcrumbHierarchyListItemHandler.handleFromMain(menuitems);
        let currentSelectedMenuItem = this.breadcrumbHierarchyListItemHandler.handleValidMenuItem(currentSelectedMenuItemId);
        let breadcrumbItemsIdArray = [];
        if (currentSelectedMenuItem != null) {
            breadcrumbItemsIdArray = currentSelectedMenuItem.ascendingParentIds;
        }
        for(let i=breadcrumbItemsIdArray.length-1; i >= 0 ; i--){
            this.breadcrumbItemList.push(this.breadcrumbHierarchyListItemHandler.getListItemById(breadcrumbItemsIdArray[i]));
        }
        //Handle sub page breadcrumb
        if (isSubPage) {
           this.breadcrumbItemList.push(this.breadcrumbHierarchyListItemHandler.handleValidMenuItem(currentSelectedMenuItemId));
         }
        return this.breadcrumbItemList;
    }

}